namespace Matrix.Workflow {
    export interface WorkflowMapBatchAssignmentRequest extends Serenity.ServiceRequest {
        TestCode?: string[];
        ResultCode?: string[];
        FailThreshold?: number;
        WorkflowCode?: string;
        HelpText?: string;
        CustomFilter?: string;
    }
}
